import { createResource } from "~/lib/resourceFactory";
import { getDocument, listDocuments } from "./document.api";

type DocumentsPage = Awaited<ReturnType<typeof listDocuments>>;
type DocumentDetail = Awaited<ReturnType<typeof getDocument>>;

export type DocumentsParams = {
  businessId: string;
  search?: string;
  offset?: number;
  limit: number;
  type?: string;
  ids?: string[];
  sortBy?: string;
  sortDir?: "asc" | "desc";
};

export type DocumentDetailParams = { businessId: string; id: string };

export const DocumentsResource = createResource<DocumentsPage, DocumentsParams>(
  {
    key: (p) =>
      [
        "document",
        p.businessId,
        p.limit,
        p.search ?? "",
        p.offset ?? 0,
        p.type ?? "",
        p.ids === undefined ? "*" : p.ids.join(","),
        p.sortBy ?? "createdAt",
        p.sortDir ?? "desc",
      ] as const,
    fetcher: (p) =>
      listDocuments({
        data: {
          businessId: p.businessId,
          search: p.search,
          offset: p.offset,
          limit: p.limit,
          type: p.type,
          ids: p.ids,
          sortBy: p.sortBy,
          sortDir: p.sortDir,
        },
      }),
    // Avoid suspending SSR when the query is disabled (no active business).
    placeholderData: { items: [], total: 0, typeCounts: [] },
  },
);

export const DocumentDetailResource = createResource<
  DocumentDetail,
  DocumentDetailParams
>({
  key: ({ businessId, id }) => ["document", businessId, id] as const,
  fetcher: ({ businessId, id }) => getDocument({ data: { businessId, id } }),
});
